export const IMAGE_LINK = '/_layouts/15/userphoto.aspx?size=S&accountname=';

export interface IIncompleteData {
    missingDataBeforeDateTime?: string;
    wasThrottled?: boolean;
}

export interface IActivity {
    activityDateTime: string;
    activityType?: string;
    actor: IActor;
    location?: ILocation;
}

export interface IActor {
    application?: string;
    user: IUser;
}

export interface IUser {
    displayName: string;
    id: string;
    email: string;
    image?: string;
}

export interface ILocation {
    address?: IAddress;
}

export interface IAddress {
    city?: string;
    countryOrRegion?: string;
    postalCode?: string;
    state?: string;
    street?: string;
}

export interface IAccess {
    actionCount: number;
    actorCount: number;
}

export interface IIncompleteDataV21 {
    missingDataBeforeDateTime: string;
    wasThrottled: boolean;
    resultsPending?: boolean;
}

export interface IKeyPointsData {
    readTime?: IReadTime;
    keyPoints?: string[];
}

export interface IReadTime {
    minutes: number;
}

export interface ILifeCycleStatus {
    status?: AnalyticsLifeCycleStatus;
    userCheckedOutThis?: IUser;
    createdRelativeTime?: string;
    creator?: IUser;
}
export enum AnalyticsLifeCycleStatus {
    MalwareDetected = 0,
    ThisFileIsCheckedOut = 1,
    DLPBlocked = 2,
    MissingMetaData = 3,
    DLPWarning = 4,
    AwaitingApproval = 5,
    Trending = 6,
    New = 7,
}